<template>
  <v-app>
    <v-col cols="auto">
      <v-dialog
          transition="dialog-bottom-transition"
          max-width="600">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
          >Toplu Sefer Güncelle</v-btn>
        </template>
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
                color="primary"
                dark
            >Toplu Sefer Güncelleme</v-toolbar>
            <v-container fluid>
              <v-select
                  v-model="selectedSails"
                  :items="sailList"
                  label="Seferler"
                  item-value="id"
                  multiple>
                <template slot="selection" slot-scope="data">
                  <!-- HTML that describe how select should render selected items -->
                  <div style="width: 30%">
                  {{ data.item.id }} - {{ data.item.sailDate | ddMMyyyy}}
                  </div>

                </template>
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item.id }} - {{ data.item.sailDate | ddMMyyyy }}
                </template>
                <template v-slot:prepend-item>
                  <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="selectAllSails">
                    <v-list-item-action>
                      <v-icon :color="selectedSails.length > 0 ? 'indigo darken-4' : ''">
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Tümünü Seç
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
<!--                  <v-divider class="mt-2"></v-divider>-->
                </template>
              </v-select>
            </v-container>
            <v-container fluid>
              <v-divider/>
            </v-container>
            <v-container fluid>
              <v-select
                  v-model="selectedCruiseRooms"
                  :items="cruiseRoomList"
                  label="Odalar"
                  item-value="id"
                  multiple>
                <template slot="selection" slot-scope="data">
                  <!-- HTML that describe how select should render selected items -->
                  <div style="width: 30%">
                    {{ data.item.roomNumber }} - {{ getRoom(data.item.roomId)}}
                  </div>

                </template>
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item.roomNumber }} - {{ getRoom(data.item.roomId)}}
                </template>
                <template v-slot:prepend-item>
                  <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="selectAllCruiseRooms">
                    <v-list-item-action>
                      <v-icon :color="selectedSails.length > 0 ? 'indigo darken-4' : ''">
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Tümünü Seç
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                      ripple>
                    <div class="row">
                      <base-edit-input
                          v-model="roomFilterTerm"
                          :label="'Filtre'"
                          :rules="'required'">
                      </base-edit-input>
                    </div>
                  </v-list-item>
                  <!--                  <v-divider class="mt-2"></v-divider>-->
                </template>
              </v-select>
            </v-container>
            <v-container fluid>
              <v-card-text>  Oda bloklama </v-card-text>
              <v-switch
                  v-model="isBlock"
                  :label="isBlock ? 'block' : 'unblock'"
              ></v-switch>
            </v-container>
            <v-container>
              <v-select
                v-model="reservedAgencyId"
                :items="agencyList"
                item-value="id"
                item-text="email"
                label="Rezerve edilen acente"
                >
                <template slot="selection" slot-scope="data">
                  <!-- HTML that describe how select should render selected items -->
                  <div style="width: 30%">
                    {{ data.item.name }}
                  </div>
                </template>
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item.name }}
                </template>
              </v-select>
            </v-container>
            <v-container fluid>
              <v-divider/>
            </v-container>
            <v-container
                fluid>
              <v-card-text>  İşlemi zorla </v-card-text>
              <v-switch
                  v-model="isForce"
                  :label="isForce ? 'force' : '-'"
              ></v-switch>
            </v-container>

            <v-card-actions class="justify-end">
              <v-btn
                  text
                  @click="dialog.value = false"
              >Close</v-btn>
              <v-btn
                  color="primary"
                  text
                  @click="save(dialog)"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-col>
  </v-app>
</template>

<script>
import UploadImage from "../common/UploadImage";
import BaseEditInput from "../base/BaseEditInput";
import BaseTextAreaInput from "../base/BaseTextAreaInput";
import BaseImageEditInput from "../base/BaseImageEditInput";
import BaseSelectInput from "../base/BaseSelectInput";
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "SailBatchUpdateModal",
  components: {UploadImage, BaseImageEditInput, BaseTextAreaInput, BaseEditInput, BaseSelectInput},
  data:function (){
    return{
      selectedSails: [],
      selectedCruiseRooms: [],
      isBlock: false,
      isForce: false,
      reservedAgencyId: 0,
      roomFilterTerm : null
    }
  },
  props : {
    sailList: null,
  },
  computed:{
    // sailList:{
    //   get(){
    //     return this.$store.getters.getSailList;
    //   }
    // },
    cruiseRoomList:{
      get(){
        if(this.$store.getters.getCruiseRoomList === null|| this.$store.getters.getCruiseRoomList === undefined){
          return [];
        }
        let cruiseRoomList = this.$store.getters.getCruiseRoomList;
        cruiseRoomList = cruiseRoomList.sort( (a, b) => {

          try{
            return (parseInt(a.roomNumber) > parseInt(b.roomNumber)) ? 1 : -1;
          }catch (ex){
            return -1
          }
        })

        if(this.roomFilterTerm){
          console.log("a");
          let rooms = this.roomFilterTerm.split(",");

          cruiseRoomList = cruiseRoomList.filter((room)=>{
             return rooms.includes(room.roomNumber);
          })
        }

        return cruiseRoomList;
      }
    },
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList;
      }
    },
    roomList:{
      get(){
        return this.$store.getters.getRoomList;
      }
    },
    cabinTypeList:{
      get(){
        return this.$store.getters.getCabinTypeList
      }
    },
    roomMap:{
      get(){
        let roomList = this.$store.getters.getRoomList;
        if(roomList == null){
          return null;
        }
        return roomList.reduce(function (map, cabinType) {
          map[cabinType.id] = cabinType;
          return map;
        }, {});
      }
    }
  },
  methods:{
    applyRoomFilter(){

    },
    selectAllSails () {
      this.$nextTick(() => {
        if (this.selectedSails.length === this.sailList.length) {
          this.selectedSails = []
        } else {
          this.selectedSails = this.sailList.map((sail) => sail.id);
        }
      })
    },
    selectAllCruiseRooms () {
      this.$nextTick(() => {
        if (this.selectedCruiseRooms.length === this.cruiseRoomList.length) {
          this.selectedCruiseRooms = []
        } else {
          this.selectedCruiseRooms = this.cruiseRoomList.map((cruiseRoom) => cruiseRoom.id);
        }
      })
    },
    getRoom(roomId){
      if(this.roomMap === undefined){
        return "-"
      }
      let room = this.roomMap[roomId];
      if(room === undefined){
        return "";
      }else{
        return room.name;
      }
    },
    save(dialog){
      this.$store.dispatch("sailBatchUpdate",
        {
          sailIds: this.selectedSails,
          cruiseRoomIds: this.selectedCruiseRooms,
          block: this.isBlock,
          force: this.isForce,
          reservedAgencyId: this.reservedAgencyId}
      ).then(response => {
        if(response.updated){
          dialog.value = false;
          messagePopupManager.showSuccess();
        }else{
          Swal.fire({
            icon: 'warning',
            title: 'Güncelleme Başarısız',
            html: response.errors.join("<br>"),
          })
        }
      }).catch(error => {
        Swal.fire({
          icon: 'warning',
          title: 'ops:(',
          text: "Something went wrong.",
        })
      });
    }
  }
}
</script>

<style>

.v-application--wrap {
  min-height: unset;
}

</style>